import { render, staticRenderFns } from "./picture.vue?vue&type=template&id=2fc645e9&scoped=true"
import script from "./picture.vue?vue&type=script&lang=js"
export * from "./picture.vue?vue&type=script&lang=js"
import style0 from "./picture.vue?vue&type=style&index=0&id=2fc645e9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc645e9",
  null
  
)

export default component.exports